import React from 'react';
import useDefault from "../tools/useDefault";
import {ArrowType} from "../tools/ArrowType";
import "../tools/arrow.css"
import "./PictureShowButton.css"

const classNames = require('classnames');

export default function PictureShowButton(props: {
    arrowType?: ArrowType,
    disabled?: boolean
    onClick?: () => void
}) {
    props = useDefault(props, {
        arrowType: ArrowType.LEFT
    });

    return (
        <div
            className={classNames("picture-show-button", props.arrowType === ArrowType.RIGHT ? "picture-show-button-right" : "")}>
            <button disabled={props.disabled}
                    onClick={props.onClick}
                    className={classNames("picture-show-button-button",
                        props.arrowType === ArrowType.RIGHT ? "picture-show-button-button-right" : "")}>
                <div
                    className={classNames(props.arrowType, "picture-show-button-arrow",
                        props.disabled ? "picture-show-button-arrow-disabled" : "")}/>
            </button>
        </div>
    )
}